import { useCallback } from 'react'
import {
  TradingViewPlanDto,
  TradingViewPlanExpirationDaysDto,
} from 'api/Trading-Accounts/Types/TradingViewPlanDto'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOne } from 'utils/api/useFetch'

export const useTradingViewPlans = () => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)
  const fetchPlans = useCallback(() => tradingAccountsApiClient.getTradingViewPlans(), []) // eslint-disable-line react-hooks/exhaustive-deps

  return useFetchOne<TradingViewPlanDto[]>(fetchPlans)
}

export const useTradingViewPlanExpirationDays = () => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)
  const fetchExpirationDays = useCallback(
    () => tradingAccountsApiClient.getTradingViewPlanExpirationDays(),
    []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  )

  return useFetchOne<TradingViewPlanExpirationDaysDto[]>(fetchExpirationDays)
}
